<template>
<v-expansion-panel focusable :value="-1">
    <v-expansion-panel-content v-for="(item, i) in plants" :key="i">
        <template v-slot:actions>
            <v-icon color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
            <v-row class="align-center">
                <v-col cols="2">
                    <v-btn icon color="info">{{ item.Details.length }}</v-btn>
                </v-col>
                <v-col cols="6">
                    <span>{{ item.PlantName }}</span>
                </v-col>
                <v-col cols="4" class="ml-4">
                    <span>Total: {{ Number(item.TotalKGs).toFixed(2) }}kg</span>
                </v-col>
            </v-row>
        </template>
        <v-layout row wrap class="pa-2">
            <v-flex v-for="(detail, j) in item.Details" :key="j" :shrink="$vuetify.breakpoint.smAndUp">
                <v-card color="blue-grey darken-2" dark>
                    <v-card-title>
                        <h3>{{ getName(detail) }}</h3>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn icon color="primary" v-on="on" @click="navigateToPage(detail.PlantID, detail.TeamID, detail.Date)"><v-icon>play_arrow</v-icon></v-btn>
                            </template>
                            <span>More</span>
                        </v-tooltip>                        
                    </v-card-title> 
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-list dense class="summary-content">
                            <v-list-tile v-if="detail.TeamName">
                                <v-list-tile-content class="pr-2">Device:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ detail.DeviceName }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content class="pr-2">Last Synched:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ detail.LastSynched | formatDateTime }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile  v-if="detail.Hours">
                                <v-list-tile-content class="pr-2">Total Hours:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ detail.Hours }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="detail.FinalKg > 0">
                                <v-list-tile-content v-if="detail.Punnets > 0" class="pr-2">Total Kg (Based on Punnet's Average Weight):</v-list-tile-content>
                                <v-list-tile-content v-else class="pr-2">Total Kg:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ detail.FinalKg }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="detail.Punnets > 0">
                                <v-list-tile-content class="pr-2">Total Punnets:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ detail.Punnets }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content class="pr-2">Total Records:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ detail.TotalRecords }}</v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-card-text>

                </v-card>
            </v-flex>
        </v-layout>
    </v-expansion-panel-content>
</v-expansion-panel>
</template>

<script>
import moment from 'moment';

export default {
    props: ['plantSummary'],
    computed: {
        plants() {
            let plants = [];

            this.plantSummary.forEach(summary => {
                let found = plants.find(item => {
                    return item.PlantID == summary.PlantID
                });

                if (!found) {
                    plants.push({
                        "PlantName": summary.PlantName,
                        "PlantID": summary.PlantID,
                        "Details": [summary],
                        "TotalKGs": summary.FinalKg,
                    });
                } else {
                    found.Details.push(summary);
                    found.TotalKGs += summary.FinalKg;
                }
            });

            return plants;
        }
    },
    methods: {
        getName(item) {
            if (item.TeamName) {
                return item.TeamName;
            }

            return item.DeviceName;
        },
        navigateToPage(plantID, teamID, date) {
            if (teamID) {
                window.location.href = "/" + process.env.VUE_APP_OLD_HMS_ROOT + "/Modules/Plants/Teams.aspx?PlantID=" + plantID + "&TeamID=" + teamID + "&DKey=" + moment(date).format('YYYYMMDD');
            } else {
                window.location.href = "/" + process.env.VUE_APP_OLD_HMS_ROOT + "/Modules/Plants/Details.aspx?PlantID=" + plantID;
            }
        }
    }
}
</script>
<style scoped>
.summary-content {
    background-color: transparent
}
.v-expansion-panel >>> .v-expansion-panel__header {
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 12px;
    padding-right: 12px;
}
</style>

